import { APP_NAME } from '@zcode/env'
import invariant from 'tiny-invariant'

invariant(typeof APP_NAME === 'string', 'Please set the REACT_APP_NAME env variable')

export const MESSAGE_FORM_MODAL = 'MESSAGE_FORM_MODAL'
export const MESSAGE_FORM_INLINE = 'MESSAGE_FORM_INLINE'
export const ONE_TAP_MESSAGE = 'ONE_TAP_MESSAGE'

export const ACCOUNT_EXISTS_ERROR_MSG =
  'Looks like an account is associated with this email. Please sign in to continue.'
// default multi-msg modal message
export const DEFAULT_MULTI_MSG =
  'Hi,\n\n' +
  `I found your listing on ${APP_NAME} and I'm interested in speaking to you about it.\n\n` +
  "Can you please let me know if it's still available, and when I might be able to view it?\n\n" +
  'Thanks'
export const DEFAULT_SEND_SUCCESS_MSG = 'Message sent!'
// Default error message
export const DEFAULT_SEND_ERROR_MSG = 'Sorry, unable to message this property at this time.'
export const CONNECTION_SEND_ERROR_MSG =
  'The connection failed. Please ensure you have an internet connection and try again.'
export const CONTACT_SUPPORT_SEND_ERROR_MSG = 'Unable to send your message.'
export const INVALID_DATE_SEND_ERROR_MSG = 'Move-in date is invalid. Please choose a future date.'
export const INVALID_EMAIL_DOMAIN_ERROR_MSG =
  'Looks like you have a typo in your email domain. Please check your spelling and try again.'
export const REFRESH_SEND_ERROR_MSG = 'Something went wrong. Please refresh the page and try again.'
export const REPLAY_SEND_ERROR_MSG =
  'You cannot message this property as you just messaged it recently. Try again later.'
export const RETRY_SEND_ERROR_MSG = 'Something went wrong. Please try again in a moment.'
export const UNAUTHORIZED_SEND_ERROR_MSG =
  'Please log in or create an account to send your message.'
// listing default msg with viewing time
export const getListingDefaultMessage = ({
  url,
  viewingTime,
}: {
  url: string
  viewingTime?: string
}) => {
  const viewingTimeText = viewingTime
    ? `I'd like to come to the viewing on ${viewingTime}.\n\n`
    : ''
  const whenToViewText = viewingTime
    ? 'and if I can view it during this time'
    : 'and when I might be able to view it'
  invariant(typeof APP_NAME === 'string')
  return (
    'Hi,\n\n' +
    `I found your listing on ${APP_NAME} and I'm interested in coming to see it: ` +
    `${url}\n\n${viewingTimeText}` +
    `Can you please let me know if it's still available, ${whenToViewText}?\n\n` +
    'Thanks'
  )
}

// building default msg
export const getBuildingDefaultMessage = ({
  url,
  buildingName = 'your building',
}: {
  url: string
  buildingName?: string
}) => {
  invariant(typeof APP_NAME === 'string')
  return (
    'Hi,\n\n' +
    `I found ${buildingName} on ${APP_NAME} (${url}) and I'd like to find out more.\n\n` +
    'Can you please let me know which floor plans are currently available, and when I might ' +
    'be able to view them?\n\nThanks'
  )
}

export const MULTI_MSG_DISPLAY_LIMIT = 6

// Equal CTAs
export const TOUR = 'Tour'
export const APPLY = 'Apply'
export const MESSAGE = 'Message'
export const WAITLIST = 'Waitlist'
